import { useMemo } from "react";
import { ExtendedProjectInfoDc } from "@evergis/api";

import { ProjectInfo } from "../../interfaces/resourceInfo";
import { project } from "../../resources/projects";
import { getProjectInfoFromExtendedProjectDc } from "../../evergis/core/project/getProjectInfoFromExtendedProjectDc";

type ProjectRefetch = ReturnType<typeof project.use>["refetch"];

export type ProjectInfoMeta = {
  error?: Error;
  loading: boolean;
  refetch: ProjectRefetch;
};
export function useProjectInfoByName(projectName: string): [ProjectInfo, ProjectInfoMeta] {
  const { data, loading, error, refetch } = project.use({ input: projectName, waitInput: true });

  return useMemo(
    () => [
      getProjectInfoFromExtendedProjectDc(data as ExtendedProjectInfoDc),
      {
        loading,
        error,
        refetch,
      },
    ],
    [data, loading, error, refetch],
  );
}
